import { Box, Grid, Image, Text } from "@mantine/core";
import useStyles from "./style";
const ComplianceAndReporting = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.InlinePadding}>
      <Box className={classes.complianceAndReportingSection}>
        <Grid gutter={0} sx={{ zIndex: 10, position: "relative" }}>
          <Grid.Col span={7}>
            <Box className="textParent">
            <Text className="heading">Compliance and Reporting</Text>
            <Text className="description">
              Maintain compliance with industry standards and regulations with
              our built-in reporting tools that generate detailed reports and
              analytics.
            </Text>
            </Box>
          </Grid.Col>
          <Grid.Col span={5}>
            <Image
              src="/assets/images/complianceAndReportingSecImg.png"
              mt={72}
            />
          </Grid.Col>
        </Grid>
        <Image
          src="/assets/images/overviewSecLeftImg.png"
          width={245}
          className="boxesImg"
        />
      </Box>
    </Box>
  );
};

export default ComplianceAndReporting;
